import { API, APP_URLS } from "@neonumy/api-clients";

const settings = {
  dashboard: APP_URLS.dashboardUrl,
  revokeToken: API.revokeToken,
  clientId: API.clientId,
  fullLoginUrl: API.fullLoginUrl,
};

export default settings;

export const APP_URL = {
  neoActiviteUrl: APP_URLS.neoActiviteUrl,
};

export const TreeTableRow = 10;
export const DATE_DISPLAY_FORMAT = "DD/MM/YYYY";
